(() => {
  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(cents / 100);

  const setMoneyText = (element, value) => {
    if (!element) return;
    const textNode = Array.from(element.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    const currencyCode = textNode?.textContent.trim().match(/\s([A-Z]{3})$/)?.[1];
    const formattedValue = currencyCode ? `${value} ${currencyCode}` : value;
    if (textNode) {
      textNode.textContent = `${formattedValue}\n`;
    } else {
      element.prepend(document.createTextNode(formattedValue));
    }
  };

  const updateProductTotal = (input, nextUnitPrice, nextCompareUnitPrice) => {
    const form = input.closest('.product-form');
    const total = form?.querySelector('[data-c2g-pdp-total]');
    const productInfo = input.closest('.product-info');
    const headline = productInfo?.querySelector('[data-c2g-headline-price]');
    if (!total && !headline) return;

    const quantity = Math.max(1, Number.parseInt(input.value, 10) || 1);
    const unitPrice = Number.parseInt(nextUnitPrice ?? total?.dataset.unitPrice ?? headline?.dataset.unitPrice, 10) || 0;
    const compareUnitPrice = Number.parseInt(nextCompareUnitPrice ?? headline?.dataset.compareUnitPrice, 10) || 0;
    const orderTotal = money(quantity * unitPrice);

    if (total) {
      total.dataset.unitPrice = String(unitPrice);
      total.textContent = orderTotal;
    }

    if (headline) {
      headline.dataset.unitPrice = String(unitPrice);
      headline.dataset.compareUnitPrice = String(compareUnitPrice);
      const salePrice = headline.querySelector('.price-item-sale.price-item-last');
      const regularPrice = headline.querySelector('.price-regular .price-item-regular');
      const comparePrice = headline.querySelector('.price-discount .price-item-regular');
      setMoneyText(salePrice || regularPrice, orderTotal);
      if (comparePrice && compareUnitPrice > unitPrice) {
        setMoneyText(comparePrice, money(quantity * compareUnitPrice));
      }
    }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.productVariantChange, ({ sectionId, variant }) => {
      const price = document.getElementById(`price-${sectionId}`);
      const productInfo = price?.closest('.product-info');
      const input = productInfo?.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"]');
      if (input && variant) {
        updateProductTotal(input, variant.price, variant.compare_at_price || 0);
      }
    });
  }

  document.addEventListener('input', (event) => {
    if (event.target.matches('.template-product .quantity-input-field')) {
      updateProductTotal(event.target);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('.template-product .quantity-input-field')) {
      updateProductTotal(event.target);
    }
  });

  document.addEventListener('click', (event) => {
	const viewBtn = event.target.closest('[data-c2g-view]');
	if (viewBtn) {
	  const isList = viewBtn.dataset.c2gView === 'list';
	  document.documentElement.classList.toggle('c2g-view-list', isList);
	  try { localStorage.setItem('c2g-view', isList ? 'list' : 'grid'); } catch (e) { /* private mode */ }
	  return;
	}

	const filterToggle = event.target.closest('[data-c2g-sidebar-toggle]');
	if (filterToggle) {
	  const layout = filterToggle.closest('.facets-wrap');
	  if (!layout) return;

	  const isCollapsed = layout.classList.toggle('c2g-filters-collapsed');
	  const label = filterToggle.querySelector('[data-c2g-sidebar-toggle-label]');
	  filterToggle.setAttribute('aria-expanded', String(!isCollapsed));
	  filterToggle.setAttribute('aria-label', isCollapsed ? 'Show filters' : 'Hide filters');
	  if (label) label.textContent = isCollapsed ? 'Show Filters' : 'Hide Filters';
	  return;
	}

    const button = event.target.closest('.template-product .quantity-input-button');
    if (!button) return;
    requestAnimationFrame(() => {
      const input = button.closest('quantity-input')?.querySelector('.quantity-input-field');
      if (input) updateProductTotal(input);
    });
  });
})();
